import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const PrimaryIconButton = styled(IconButton)(({ theme }) => ({
  '&:hover': {
    color: theme.palette.primary[theme.palette.mode],
  },
  '&:active': {
    opacity: 0.8,
  },
}));
